module.exports = __webpack_public_path__ + "img/lucky-spin.48a0c1be.png";